/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import * as _ from 'lodash';

import template from './html-insertion-widget.component.html';
import {APP_SHARED} from '../../common/app-shared';

@Component({
  standalone: true,
  imports: [...APP_SHARED],
  selector: 'adn-html-insertion-widget',
  template
})
export class HtmlInsertionWidgetComponent implements OnInit, AfterViewInit {
  @Input() widgetType: any;

  @ViewChild('previewContainer') previewContainer: ElementRef<HTMLElement>;

  hasHtml = false;

  ngOnInit(): void {
    this.hasHtml = !!this.widgetType?.html;
  }

  ngAfterViewInit(): void {
    if (this.hasHtml) {
      setTimeout(() => this.renderPreview(), 200);
    }
  }

  private renderPreview(): void {
    const container = this.previewContainer?.nativeElement;
    if (!container) {
      return;
    }
    const existingIframe = container.querySelector('iframe');
    if (existingIframe) {
      existingIframe.remove();
    }
    const iframe = document.createElement('iframe');
    iframe.setAttribute('allowTransparency', 'true');
    iframe.setAttribute('style', 'width: 100%; min-height: ' + this.widgetType.height + 'px; border: 2px solid #ddd; padding: 5px;');
    iframe.setAttribute('width', '100%');
    iframe.setAttribute('scrolling', 'yes');
    iframe.frameBorder = '0';
    container.appendChild(iframe);

    const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
    if (!iframeDoc) {
      return;
    }
    iframeDoc.open();
    iframeDoc.write(_.cloneDeep(this.widgetType.html));
    iframeDoc.close();
    const bodyElement = iframeDoc.querySelector('body');
    if (bodyElement) {
      bodyElement.setAttribute('style', 'margin: 0; padding: 0;');
    }
  }
}
